var isIE = typeof(window.document.documentMode) != "undefined";

if(typeof(window.Promise) == 'undefined'){
    window.Promise = require('promise-polyfill').default;
}
import $ from 'jquery';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import { Flip } from "../vendor/gsap/Flip.js";



//import { Flip } from "gsap/Flip.js";

///var $ = require('jquery');
//var jQueryBridget = require('jquery-bridget');
//var Flickity = require('flickity');


/* import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';

Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ ); */


gsap.registerPlugin( ScrollTrigger, ScrollToPlugin, Flip);

import {select2} from 'select2';                       // globally assign select2 fn to $ element

import Cookies from 'js-cookie';
import tippy from 'tippy.js';

import { tns } from 'tiny-slider/src/tiny-slider';

window.jQuery = $;
require('@fancyapps/fancybox');


$.fn.hasAnyClass = function() {
    var classes = arguments[0].split(" ");
    for (var i = 0; i < classes.length; i++) {
        if (this.hasClass(classes[i])) {
            return true;
        }
    }
    return false;
}
function captcha() {
    return new Promise(function(resolve, reject) {
      grecaptcha.ready(function() {
        grecaptcha.execute('6LesY-4nAAAAAN1ODjJOuxKcai6CGGEGGDP3q70w', {action: 'submit'}).then(function(token) {
          resolve(token);
        });
      });
    });
}

const forms = {
    formClass : '.form',
    $forms : null,
    floatClass: '.field-2 input, .field-3 input',
    $inputs : null,

    init: function(container){
        if(typeof container === 'undefined'){
            container = document;
        }
        let obj = this;
        obj.$forms = $(container).find(obj.formClass);
        if(obj.$forms.length){
            obj.$forms.on('submit', async function(e){
                e.preventDefault();
                let token = await captcha();
                let $this = $(this);
                let $ref = $this.find('[name="referer"]');
                $ref.val(window.location.href);
                let $btn = $this.find('button[type=submit]');
                $btn[0].disabled = true;
                let $msg = $this.find(".form-messages");

                $this
                    .find('.has-error')
                    .removeClass('has-error')
                    .find('.form-field--error')
                    .html('');

                $.ajax({
                    url:$this.attr('action'),
                    data: $this.serialize() + '&token='+token,
                    type: 'POST'
                }).done(function( data ) {
                    if(data.status === 0){
                        $.each(data.errors, function(){
                           $this.find('.form-error--'+this[1]).html(this[0]).parent().addClass('has-error');
                        });
                        $btn[0].disabled = false;
                    }else{
                        $this.find('.form-fields').hide();
                        $this.find('.form-footer').hide();
                        $msg.html(data.message).show();
                    }
                    setTimeout(function(){
                        ScrollTrigger.refresh();
                    })
                })
            });
            obj.$inputs = obj.$forms.find(obj.floatClass);
            obj.$inputs.on('keyup', function(){
                let $this = $(this);
                if($this.val() === ''){
                    $this.parent().removeClass('floatLabel');
                }else{
                    $this.parent().addClass('floatLabel');
                }
            });
        }
    }



};
const header = {
    headerClass : '.header',
    $header: null,
    init : function(container){
        if(typeof container ==='undefined'){
            container = document;
        }
        let obj = this;
        obj.$header = $(container).find(obj.headerClass);

        if(obj.$header.length){

            obj.toggle(obj.$header);

            $(document).on('scroll',function(){
                obj.toggle(obj.$header);
            })
        }
    },
    toggle : function($header){
        if($(document).scrollTop() > 2){
            $header.addClass('scrolled');
        }else{
            $header.removeClass('scrolled');
        }
    }


};
const subHeader = {
    class : '.subHeader',
    header : '.header',
    $subHeader: null,
    init: function(container){
        if(typeof  container ==='undefined'){
            container = document;
        }
        let obj = this;

        obj.$subHeader = $(container).find(obj.class);

        if(obj.$subHeader.length){
            let $trigger = $(container).find('.subHeader-bot');

            ScrollTrigger.create({
                trigger: $trigger,//obj.$subHeader,
                start: "top "+offset(),
                end:  end,
                scrub: 1,
                anticipatePin: 1,
                toggleClass : 'pinned',
           //     markers: true
            });
        }

        function end(){
            return  $(container).height()
        }

        function offset(){
            return $(document).width() / 100 * 4.5;
        }

    }
};

const formFloat = {
    class: '.coSct-2-form',
    $form: null,
    endClass : '.coSct-2--inner',
    init: function(container){
        if(typeof  container ==='undefined'){
            container = document;
        }

        let start = 'top 30%';
        let end = 'bottom 90%';
        if(window.innerHeight <700) {
            start = 'top 13%';
            end = 'bottom 98%';
        }

        let obj = this;
        obj.$form = $(container).find(obj.class);
        if(obj.$form.length){
            ScrollTrigger.create({
                trigger: obj.$form,
                start: start,
                pin: true,
                end: end,
                // markers: true,
                endTrigger: $(obj.endClass)
            });
        }

    }
};
const scrollTo = {
    class : '.scroll-to',
    init : function(){
        let obj = this;
        $(document).on('click', obj.class, function(e){
            e.preventDefault();
            let $this = $(this);
            let target = $this.data('target');

            let $target = $(target);

            let offset = 0;
            let pos = 0;
            let sub = 0;
            let $sub = $('.subHeader-bot');

            if($sub.length > 0) {
                if (target !== '.coSct-2') {
                    sub = $sub.height() - 2;
                }
            }
            if(target !== 'top'){
                offset =  $('.header-inner').height() -2 + sub;
            }
            if($target.length){
                pos = $target.offset().top;
            }

           // if(offset)


            gsap.to(window, {scrollTo: pos - offset});

        })

    }
};
const maps = {
    container: '.map-container',
    $container: null,
    map: null,
    instance: null,
    styleClass: 'gmap',
    markers: [],
    infoWindows: [],
    btnClass : '.map-button',
    $btns: null,
    locs: {
        air: {
            title: '',
            lat : 54.63799420138203,
            lng : 25.285470775216965
        },
        train: {
            title: '',
            lat: 54.670414764602086,
            lng:  25.284370662961123
        }
    },
    style:{
        1: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7f7f7f"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#fce0df"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#272727"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#e9c2c1"
                    },
                    {
                        "lightness": 21
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5cdcb"
                    },
                    {
                        "lightness": 21
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#7f7f7f"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#f0cac9"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#f0cac9"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7f7f7f"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f0cac9"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#7f7f7f"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "color": "#aeaeae"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f0cac9"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f0cac9"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#9e78cd"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ],
        2: [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#333333"
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7f7f7f"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#fbe3bc"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#272727"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dfc08d"
                    },
                    {
                        "lightness": 21
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5d49f"
                    },
                    {
                        "lightness": 21
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#7f7f7f"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#edca92"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#f0cac9"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7f7f7f"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#edca92"
                    },
                    {
                        "lightness": 18
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#7f7f7f"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "color": "#aeaeae"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#edca92"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#edca92"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#1862e5"
                    },
                    {
                        "lightness": 17
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            }
        ]
    },
    polylines:{
        1: '#e75115',
        2: '#12364b'
    },
    end: null,
    options: {
        center: null,
        zoom: 16,
        panControl: false,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER,
        },
        mapTypeControl: false,
        overviewMapControl: false,
        scaleControl: false,
        streetViewControl: false,
        scrollwheel: false,
        fullscreenControl: false,
        gestureHandling: 'cooperative',
    },
    init: function(container){

        container = document;

        let obj = maps;

        obj.$container = $('.map-container');

        obj.end = {
            addr: obj.$container.data('addr'),
            lat : obj.$container.data('lat'),
            lng : obj.$container.data('lng')
        };

        if(obj.$container.length === 0){
            return false;
        }

        if(obj.instance === null || typeof obj.instance === 'undefined'){

            obj.options.styles = obj.style[obj.$container.data('type')];

            obj.options.zoomControl = true;
            obj.options.zoomControlOptions = {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
            }

            obj.options.center = new google.maps.LatLng( obj.end.lat, obj.end.lng);

            obj.instance = obj.createNewInstance();


            let directionsService = new google.maps.DirectionsService();
            let directionsRenderer = new google.maps.DirectionsRenderer({
                    suppressMarkers: true,
                    polylineOptions: { strokeColor: obj.polylines[obj.$container.data('type')] }
                });

            let bounds = new google.maps.LatLngBounds();

            let icon = {
                url: 'assets/svg/ikona_pin'+ obj.$container.data('type')+'.svg',
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(12, 34),
                scaledSize: new google.maps.Size(25, 34)
            };



            obj.main = new google.maps.Marker({
                position: obj.options.center ,

           //     position: new google.maps.LatLng(54.67436555893993, 25.25786446530608),
                map: obj.instance.map,
                icon: icon,
                visible: true,
                zIndex: 80,
            });
            bounds.extend( obj.options.center);


            let infoContent =
                '<div class="gmap-info gmap-info--main">' +
                '<div class="gmap-info--inner">' +
                '<div class="gmap-info--title">'+obj.end.addr+'</div>' +
                '</div>'+
                '</div>';

            let infowindow = new google.maps.InfoWindow({
                content: infoContent
            });

            google.maps.event.addListener( obj.main, 'click', function () {
                infowindow.open(obj.instance.map, obj.main);
            });

            if(obj.$container.hasClass('map-contacts')){


                obj.main2 = new google.maps.Marker({
                    position: new google.maps.LatLng(obj.$container.data('lat2'), obj.$container.data('lng2')),
                    map: obj.instance.map,
                    icon: icon,
                    visible: true,
                    zIndex: 80,
                });

                bounds.extend( new google.maps.LatLng(obj.$container.data('lat2'), obj.$container.data('lng2')));

                obj.main3 = new google.maps.Marker({
                    position: new google.maps.LatLng(obj.$container.data('lat3'), obj.$container.data('lng3')),
                    map: obj.instance.map,
                    icon: icon,
                    visible: true,
                    zIndex: 80,
                });
                
                bounds.extend( new google.maps.LatLng(obj.$container.data('lat3'), obj.$container.data('lng3')));

                obj.instance.map.fitBounds(bounds);


                let infoContent2 =
                    '<div class="gmap-info gmap-info--main">' +
                    '<div class="gmap-info--inner">' +
                    '<div class="gmap-info--title">'+obj.$container.data('addr2')+'</div>' +
                    '</div>'+
                    '</div>';

                let infowindow2 = new google.maps.InfoWindow({
                    content: infoContent2
                });

                google.maps.event.addListener( obj.main2, 'click', function () {
                    infowindow2.open(obj.instance.map, obj.main2);
                });

                let infoContent3 =
                '<div class="gmap-info gmap-info--main">' +
                '<div class="gmap-info--inner">' +
                '<div class="gmap-info--title">'+obj.$container.data('addr3')+'</div>' +
                '</div>'+
                '</div>';

                let infowindow3 = new google.maps.InfoWindow({
                    content: infoContent3
                });

                google.maps.event.addListener( obj.main3, 'click', function () {
                    infowindow3.open(obj.instance.map, obj.main3);
                });


            }

            obj.$container.html(obj.instance['div']);

            directionsRenderer.setMap(obj.instance.map);

            //obj.buttons(container, directionsRenderer , directionsService);
        }

    },
    createNewInstance : function(){
        let obj = this;
        let div = $("<div></div>").addClass(this.styleClass);
        let map = new google.maps.Map(div[0], obj.options);

        return {
            map: map,
            div: div
        }
    },
    buttons: function(container, directionsRenderer , directionsService){
        let obj = this;
        obj.$btns = $(obj.btnClass);

        if(obj.$btns.length){
            obj.$btns.on('click', function(){
                let $this = $(this);
                let type = $this.data("type");

                let request = {
                   // origin: new google.maps.LatLng(54.63802253429256, 25.284842433360204),
                    destination: new google.maps.LatLng( obj.$container.data('lat'), obj.$container.data('lng')),
                    travelMode: 'DRIVING'
                };

                if(!$this.hasClass('active')) {

                    switch(type){
                        case('loc'):
                            function success(position) {

                                request.origin = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                                draw(request.origin);
                            }
                            function error() {
                                alert('Unable to retrieve your location');
                            }
                            if(navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition(success, error);
                            }else{
                                alert('Geolocation is not supported by your browser');
                            }
                            break;
                        default:
                            request.origin = new google.maps.LatLng(obj.locs[type]['lat'], obj.locs[type]['lng']);
                            draw(request.origin);
                            break;
                    }
                }

                function draw(result){
                    directionsService.route(request, function(result, status) {
                        if (status == 'OK') {
                            directionsRenderer.setDirections(result);
                        }
                    });
                }



            })
        }
    }

};
const fp_header = {
    images: [],
    images_loaded: false,
    init_waiting: false,
    next_elem: null,
    img_amt: 3,
    crt: null,
    plane: null,
    title: null,
    tween: null,
    res: null,
    mouse: {
        mx: 0,
        rx: 0,
        side: 0
    },
    isAnimating: false,
    cPos: 0,
    params: {
        vertexShader: `#ifdef GL_ES
        precision mediump float;
        #endif
        
        attribute vec3 aVertexPosition;
        attribute vec2 aTextureCoord;
        
        uniform mat4 uMVMatrix;
        uniform mat4 uPMatrix;
        
        uniform mat4 uTextureMatrix0;
        
        varying vec3 vVertexPosition;
        varying vec2 vTextureCoord;
        
        void main() {
            mat4 tmt = uMVMatrix;
            gl_Position = uPMatrix * tmt * vec4(aVertexPosition, 1.0);
            
            vTextureCoord = (uTextureMatrix0 * vec4(aTextureCoord, 0.0, 1.0)).xy;
            vVertexPosition = aVertexPosition;
        }
    `,
        fragmentShader: `precision mediump float;

        varying vec3 vVertexPosition;
        varying vec2 vTextureCoord;

        uniform float uTime;
        uniform vec2 uRes;
        uniform sampler2D uSampler0;
        uniform sampler2D uSampler1;
        uniform sampler2D uSampler2;

        float sdRoundRect(vec2 pos, vec2 ext, vec4 cr) {
            vec2 s = step(pos, vec2(0.0));
            float r = mix(
                mix(cr.y, cr.z, s.y),  
                mix(cr.x, cr.w, s.y),
            s.x);
            return length(max(abs(pos) + vec2(r) - ext, 0.0)) - r;
        }

        void main( void ) {
            vec4 distex = texture2D(uSampler2, vTextureCoord) * -0.2; //* -0.2

            vec2 fdcord = vTextureCoord + distex.r * cos(uTime * 1.570796 + 4.712388);
            vec4 fdcol = texture2D(uSampler0, vec2(vTextureCoord.x, fdcord.y));

            vec2 sdcord = vTextureCoord - distex.r * cos((1.0 - uTime) * 1.570796 + 4.712388);
            vec4 sdcol = texture2D(uSampler1, vec2(vTextureCoord.x, sdcord.y));
            
            vec4 ecol = mix(fdcol, sdcol, smoothstep(clamp(1.0 - uTime, 0.0, 1.0), 1.5 - uTime, (texture2D(uSampler2, vTextureCoord).g*0.6)+0.5));
            

            vec2 pos = vVertexPosition.xy;
            float ratio = uRes.y / uRes.x;
            vec2 boxPosition = vec2(0.0, 0.0);
            vec2 boxExt = vec2(1.0, 1.0);
            vec4 cornerRadii = vec4(0.07, 0.07, 0.07, 0.07);
            ecol.a = smoothstep(0.01, 0.0, sdRoundRect(pos - boxPosition, boxExt, cornerRadii));

            gl_FragColor = ecol;
        }
    `,
        watchScroll: true,
        pixelRatio: Math.min(1.5, window.devicePixelRatio),
        uniforms: {
            time: {
                name: "uTime", // uniform name that will be passed to our shaders
                type: "1f", // this means our uniform is a float
                value: 0,
            },
            res: {
                name: "uRes",
                type: "2f",
                value: [1,1]
            }
        },
    },
    preInit: function(elem=document){
        let $this = this;
        var el = $(elem);
        let imgs = el.find(".tran-planes img");
        //let img_names = ["coliving-foto.jpg", "coworking-foto.jpg", "mask.png"];
        $this.img_amt = imgs.length;

        imgs.each(function () {
            let img = new Image();
            img.addEventListener("load", (e)=>{
                console.log("loaded: ", e.target.src);
                $this.img_amt--;
                if($this.img_amt == 0){
                    console.log("All images loaded");
                    $this.images_loaded = true;
                    if($this.init_waiting){
                        $this.init_waiting = false;
                        $this.init($this.next_elem);
                    }
                }
            });
            img.src = this.getAttribute("src");
            $this.images.push(img);
        });
    },
    init: function(elem=document){
        var $this = this;
        //console.log("Try curtain init");
        if(!$this.images_loaded){
            //console.log("delay curtain init");
            $this.next_elem = elem;
            $this.init_waiting = true;
            return true;
        }
        //console.log("curtain init going");

        $this.cPos = 0;
        $this.isAnimating = false;
        var el = $(elem);
        let planeElement = el.find(".tran-planes").first().get(0);
        let container = el.find("#tran-cvs").get(0);

        $this.crt = new Curtains({
            container: container
        });

        $this.plane = new Plane($this.crt, planeElement, $this.params);
        $this.isAnimating = true;
        //$this.crt.disableDrawing();

        $this.plane.onLoading((tex)=>{
            tex.setMinFilter($this.crt.gl.LINEAR_MIPMAP_NEAREST);
        }).onReady(() => {
            $(container).addClass("loaded");
            let pln = $this.plane.getBoundingRect();
            $this.res = [1,1];
            $this.res[0] = pln.width;
            $this.res[1] = pln.height;
            $this.plane.uniforms.res.value = $this.res;

            
            $this.mouse.rx = 0;
            $this.mouse.mx = 0;
            $this.mouse.side = 0;
            /* window.addEventListener("mousemove", $this.mmove);
            window.addEventListener("touchmove", $this.mmove, {
                passive: true
            }); */

            el.find('.tran-button').on('mouseenter', function(){
                let $el = $(this);
                var oSide = $this.mouse.side;
                $this.mouse.side = $el.hasClass('tran-button--1')?0:1;
                if(oSide != $this.mouse.side) {
                    $this.plane.resize();
                    $this.isAnimating = true;
                    $this.crt.enableDrawing();
                }
            });
        }).onRender(() => {
            if($this.isAnimating){
                $this.cPos += ($this.mouse.side - $this.cPos) * 0.07; //0.05
                
                if(Math.abs($this.mouse.side - $this.cPos) < 0.001){
                    $this.isAnimating = false;
                    //console.log("Animation done");
                    $this.plane.uniforms.time.value = $this.mouse.side;
                    $this.crt.disableDrawing();
                }else{
                    $this.plane.uniforms.time.value = $this.cPos;
                }
            }
        }).onAfterResize(()=>{
            let pln = $this.plane.getBoundingRect();
            $this.res[0] = pln.width;
            $this.res[1] = pln.height;
            $this.crt.needRender();
        });

    },
    deinit: function(){
        //console.log("curtain deinit");
        var $this = this;
        /* window.removeEventListener("mousemove", $this.mmove);
        window.removeEventListener("touchmove", $this.mmove, {
            passive: true
        }); */


        //console.log("curtain events gone");
        $this.plane.remove();
        //console.log("curtain plane gone");
        $this.crt.dispose();

        $this.tween.kill();
        //console.log("curtain crt gone");
    },
    initIE: function(elem=document){
        var $this = this;
        var el = $(elem);
        var img = el.find('.tran-planes img').eq(1);
        el.find('.tran-button').on('mouseenter', function(){
            let $el = $(this);
            img.css("opacity", $el.hasClass('tran-button--1')?0:1);
        });
    }
}
const opti = {
    toggleClass: '.opti-changer, .apart-changer',
    $toggle: null,
    $container: null,
    init: function(container){

        if(typeof container === 'undefined'){
            container = document;
        }

        let obj = this;
        obj.$toggle = $(container).find(obj.toggleClass);
        
        if(obj.$toggle.length){
            obj.$container = $(container).find(obj.$toggle.parent());
            obj.$toggle.on('click', function(e){
                e.preventDefault();
                obj.$container.toggleClass('opti-alt');
            })

        }
    }
};
const ch_sliders = {
    first: true,
    fs: {
        e: null,
        f: null,
        fi: null
    },
    init: function(elem=document) {
        let $this = this;
        let el = $(elem);

        let sliders = el.find(".slider-container");
        sliders.each(function (index, element) {
            let e = $(element);
            let slider = e.find('.slider').flickity({
                // options
                lazyLoad: true,
                cellAlign: 'center',
                contain: true,
                prevNextButtons: false,
                pageDots: false
            });

            let sliderI = slider.data('flickity');

            let nav = e.find(".slider-nav");
            let bullets = nav.find('.slider-bullets');
            
            bullets.html('');

            if(sliderI.cells.length > 1) for(let i=0; i<sliderI.cells.length; i++){
                bullets.append('<div class="slider-bullet"></div>');
            }

            let bullet = bullets.find('.slider-bullet');
            bullet.eq(sliderI.selectedIndex).addClass('active');

            let $imgs = slider.find('.carousel-cell img');
            // EVENTS

            slider.on( 'select.flickity', function() {
                bullet.removeClass('active');
                bullet.eq( sliderI.selectedIndex ).addClass('active');
            });

            bullets.on('click', '.slider-bullet', function(){
                var index = $(this).index();
                slider.flickity( 'select', index );
            });

            nav.on("click", ".slider-btn.left", function(){
                slider.flickity('previous');
            });

            nav.on("click", ".slider-btn.right", function(){
                slider.flickity('next');
            });

            slider.on( 'scroll.flickity', function() {
                sliderI.slides.forEach( function( slide, i ) {
                    var img = $imgs[i];
                    var x = ( slide.target + sliderI.x ) * -1/3;
                    img.style[ 'transform' ] = `translateX(${x}px)`;
                });
            });
            let sTop = 0;
            sliderI.on('staticClick', function(ev, ptr, el, id){
                //console.log(ev);
                ev.preventDefault();
                ev.stopPropagation();
                if(typeof el == 'undefined') return false;
                const state = Flip.getState(e);
                
                setTimeout(function(){
                    $this.fs.e = e;
                    $this.fs.f = slider;
                    $this.fs.fi = sliderI;
                    e.toggleClass('isFullScreen');
                    $('body').toggleClass('isFullScreen');
                    sliderI.resize();
                    sliderI.reposition();
                    slider.find('.flickity-viewport').css('height', '');
                    Flip.from(state, {duration: 0.3, ease: "expo.out", scale: true});
                }, 50);
                
                
            });
        });

        if(ch_sliders.first){
            var sliderResTimer = 0;
            window.addEventListener('resize', function(){
                clearTimeout(sliderResTimer);
                sliderResTimer = setTimeout(function(){
                    el.find('.flickity-viewport').css('height', '');
                }, 200);
            });

            window.addEventListener('keydown', function(e){
                if(e.key.toLowerCase() == 'escape' && $('body').hasClass('isFullScreen')){
                    const state = Flip.getState($this.fs.e);
                    $this.fs.e.toggleClass('isFullScreen');
                    $('body').toggleClass('isFullScreen');
                    $this.fs.fi.resize();
                    $this.fs.fi.reposition();
                    $this.fs.f.find('.flickity-viewport').css('height', '');
                    Flip.from(state, {duration: 0.3, ease: "expo.out", scale: true});
                }
            });
        }
        ch_sliders.first = false;

    },
    deinit: function(elem) {
        let $this = this;
    },
};
const ch_cospace_slider = {
    init: function(elem=document){
        let $this = this;
        let el = $(elem);
        let sliders = el.find(".areaTabs .areaTabs-inner, .events .events-inner");

        sliders.each(function (id, ar) {
            // element == this
            let area = $(ar);
          //  let tabs = area.find(".areaTabs-tab, .event-controls button");
            let slider = area.find(".areaContainer-left .slider-container, .event-right .slider-container");
            let txt = area.find(".areaContainer-right .areaContainer-txt, .event-left .event-txt");
            let tmo = 0;
            let isEvent = txt.hasClass("event-txt");
            let eState;

            area.on('click', ".areaTabs-tab, .event-controls button", function(){
                //tabs.on("click", function(){
                if($("body").hasClass("isFullScreen")) return false;
                let tab = $(this);
                area.find(".areaTabs-tab, .event-controls button").removeClass("active");
                tab.addClass("active");
                let txtData = undefined;
                let sliderData = undefined;

                //TODO ajax load JSON and set txtData and sliderData

                slider.css("opacity", 0);
                txt.addClass('hidden');
                clearTimeout(tmo);

                if(isEvent) eState = Flip.getState(txt);

                $.ajax({
                    url:tab.data('url'),
                    data: {id : tab.data('id')},
                    type: 'POST'
                }).done(function( data ) {
                    data = JSON.parse(data);
                    txtData = data.txtData;
                    sliderData = data.sliderData;

                    tmo = setTimeout(function(){
                        setData();  // <-- Uncomment when ajax is implemented.
                       // Comment this out when ajax is implemented
                        slider.css("opacity", '');
                        txt.removeClass('hidden');
                        if(isEvent) Flip.from(eState, {duration: 0.5, ease: "expo.out", scale: true});
                    }, 500);
                });

                

                function setData(){

                    if(typeof(txtData) == 'undefined' || typeof(sliderData) == 'undefined') {
                        tmo = setTimeout(setData, 100);
                        return false;
                    }

                    slider.find('.slider').flickity("destroy");

                    txt.html(txtData);
                    slider.html(sliderData);

                    ch_sliders.init(slider.parent());

                    slider.css("opacity", '');

                    txt.removeClass('hidden');
                }
            });
        });
    }
}
const reveal = {
    class: '.reveal',
    $reveals: null,
    init: function (container = document) {

        let obj = this;
        obj.$reveals = $(container).find(obj.class);

        if (obj.$reveals.length > 0) {
            $.each(obj.$reveals, function () {
                let $this = $(this);
                ScrollTrigger.create({
                    trigger: $this,
                    start: "top 75%",
                    onEnter: function (st) {
                        $this.removeClass("reveal");
                        setTimeout(function(){
                            $this.removeClass("to-anim");
                        }, 900);
                    },
                    once: true
                });
            });
        }
    }
};

const stagger = {
    class: '.stagger-up, .stagger-left, .stagger-op, .stagger-right',
    $stagger: null,
    init: function (container = document) {
        let obj = this;
        obj.$stagger = $(container).find('.stagger');
        if (obj.$stagger.length > 0) {

            $.each(obj.$stagger, function () {
                let $this = $(this);

                ScrollTrigger.create({
                    trigger: $this,
                    start: "top 75%",
                    onEnter: (st) => {
                        let $el = $this;
                        let $elems = $el.find(obj.class);
                        if ($el.find('.tran-planes').length > 0) {
                            let tobj = {
                                tt: 0
                            };
                            gsap.to(tobj, {
                                duration: 1.5,
                                tt: 10,
                                onUpdate: function () {
                                    if (fp_header.plane) fp_header.plane.resize();
                                    if (fp_header.crt) fp_header.crt.needRender();
                                }
                            });
                        }
                        gsap.set($elems, {
                            stagger: {
                                each: 0.05,
                                onComplete: function () {
                                    let rel = $(this._targets[0]);
                                    rel.removeClass("stagger-up stagger-left stagger-op stagger-right");
                                    setTimeout(function(){
                                        rel.removeClass("to-anim");
                                    }, 900);
                                }
                            }
                        });
                    },
                    //markers: true,
                    once: true
                });
            });
        }
    }
};

const front = {
    class: '.sct-main',
    $main: null,
    init: function (container = document) {
        let obj = this;

        obj.$main = $(container).find(obj.class);

        if (obj.$main.length > 0) {
        }
    }
};
function popup(){

    let $trigger = $('.popup-trigger');
    let $popup = $('#popup');

    if($trigger.length > 0
        && $popup.length > 0
        && typeof Cookies.get(popup_cookie) === 'undefined'){

        setTimeout(function(){
            $trigger.trigger('click');
            Cookies.set(popup_cookie, '1', popup_denied);
        },popup_delay*1000);
    }
}

const Apartments = {
  init: function() {
    // const c = document.querySelector('.coSct-1');
    // if(c == undefined) return;
    // if(c.dataset['type'] == undefined) return;

    // console.log( document.querySelectorAll('.cordianion .title'));
    const popEl = document.querySelectorAll('.popup-icon');
    document.addEventListener('click', (e) => {
      if(
          !e.target.classList.contains('popup-icon') ||
          !e.target.classList.contains('bnt-popup')) popEl.forEach(el => el.classList.remove('active'));
    });

    popEl.forEach(el => {
      el.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('active');
      })
    });


    document.querySelectorAll('.cordianion .title').forEach((el) => {
      el.addEventListener('click', function() {
        const content = document.querySelectorAll('.cordianion .content');
        const state = Flip.getState(content, {simple: true});
        if(el.parentElement.classList.contains('active')){
          el.parentElement.classList.remove('active');
        }else{
          const elOld =document.querySelector('.cordianion.active');
          if(elOld) elOld.classList.remove('active');
          el.parentElement.classList.add('active');
        }

        setTimeout(() => {
          gsap.to(window, {duration: 0.8, ease: "power3.out", scrollTo: {y: el, offsetY: 180}});
        },480)
        
        Flip.from(state, {
          duration: 0.5,
          ease: "power3.out",
          props: "height",
          prune: true
        })
      });
    });
  }
}
$(document).ready(function(){


    window.onbeforeunload = function () {
    //    window.scrollTo(0, 0);
    };

    opti.init();
    forms.init();
    header.init();
    subHeader.init();
    scrollTo.init();
    Apartments.init();

    formFloat.init();
  //  maps.init();

    ScrollTrigger.create({
        trigger: '.map',
        onEnter: maps.init,
        //markers:true
    });

    $(document).on('resize', function(){
        if(typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.refresh();
        }
    });




    // test
    if($("#tran-cvs").length > 0){
        //import {Curtains, Plane} from 'curtainsjs';
        if(isIE){
            $(".tran-planes").addClass("isIE");
            fp_header.initIE();
        }else{
            import('curtainsjs').then((curt) => {
                window.Curtains = curt.Curtains;
                window.Plane = curt.Plane;
                window.Vec2 = curt.Vec2;
                fp_header.preInit();
                fp_header.init();
            });
        }
    }

    if($(".slider-container").length > 0){
        var oneLoaded = false;
        var bridge = null;
        import('jquery-bridget').then((jqb) => {
            bridge = jqb.default;
            if(oneLoaded){
                flicketyLoaded();
            }else{
                oneLoaded = true;
            }
        });

        
        import('flickity').then((flick) => {
            window.Flickity = flick.default;
            if(oneLoaded){
                flicketyLoaded();
            }else{
                oneLoaded = true;
            }
        });

        function flicketyLoaded(){
            window.Flickity.setJQuery( jQuery );
            bridge( 'flickity', window.Flickity, jQuery );
            ch_sliders.init();
        }
    }

    if($('.areaTabs, .events ').length > 0){
        ch_cospace_slider.init();
    }



    let $menuToggle = $('.menu-toggle');
    let $mobMenu = $('.menu-mobile');
    $menuToggle.on('click', function(){
        let $this = $(this);
        $this.toggleClass('close');
        $mobMenu.toggleClass('active');
        $('.header').toggleClass('show-langs');
    });

    let $select = $('.select2');

    if($select.length > 0){
       $select.select2({
           // placeholder: 'Pasirink, kur gyvensi',
            minimumResultsForSearch: -1
        });

        $select.on("select2:select", function (e) {
            window.location.href = e.params.data.id;
        });
    }

    stagger.init();
    reveal.init();

    $('.js-cam').on('click',function(e){
        e.preventDefault();
        console.log('!');
        $('.page-gdpr-1').addClass('is-active');
        $('.cover').addClass('is-active');
    });

    $('.btn-gdpr').on('click',function(e){
        e.preventDefault();
        $('.page-gdpr').addClass('is-active');
        $('.cover').addClass('is-active');
    });

    $('.page-gdpr--close button').on('click',function(e){
        e.preventDefault();
        $('.page-gdpr-1').removeClass('is-active');
        $('.page-gdpr').removeClass('is-active');
        $('.cover').removeClass('is-active');
    });

    let $cookies = $('.cookies');
    if(typeof Cookies.get('gdpr') === 'undefined' && $cookies.length > 0){
        setTimeout(function () {
            $cookies.addClass('active');
        }, 800)
    }
    $('.btn-gdpr--accept').on('click', function(e){
        e.preventDefault();
        $cookies.removeClass('active');
        Cookies.set('gdpr', '1');
    });

    $('.js-call-tooltip').on('click', function(e){
        e.preventDefault();
    });

    tippy('.js-call-tooltip', {
        content: $('.tooltip-template').html(),
        allowHTML: true,
        trigger: 'click',
        zIndex: 21,
        interactive: true,
        placement: 'bottom',
        onShow(instance) {
            $(document).on('click', '.tooltip__close', function () {
                instance.hide();
            });
        },
    });


    let $simple = $('.slider-simple');

    $.each($simple,function(){
        let $this = $(this);
        let slider = tns({
            container: this,
            items: 4,
            slideBy: 1,
            gutter: 0,
            padding: 0,
            loop: true,
            edgePadding:0,
            nav: false,
            prevButton: $this.parent().find('.btn2-left')[0],
            nextButton: $this.parent().find('.btn2-right')[0],
            responsive: {
                300: {
                    items: 1
                },
                490: {
                    items: 2
                },
                620: {
                    items: 3,
                },
                960: {
                    items: 4
                }
            }
        });
    })

    popup();
    const $extra = $('.toggleLinks');
    $(document).on('click','.btn-switch', function(){
        let $this = $(this);
        $this.toggleClass('clicked');
        $('.apart-price').toggleClass('active');
        let url = window.location.href;
        url = url.split('?');
        if($this.hasClass('clicked')){
            history.pushState({}, null, url[0]+'?price=day');
            if($extra.length > 0){
                $extra.attr('href', $extra.data('day'))
            }
        }else{
            history.pushState({}, null, url[0]+'?price=month');
            if($extra.length > 0){
                $extra.attr('href', $extra.data('month'))
            }
        }

    })

    const request = window.location.search;
    if($('.coSct-2--switch').length && request.length > 0){
        const urlParams = new URLSearchParams(request);
        if(urlParams.get('price') === 'day'){
            $('.btn-switch').addClass('clicked');
            $('.apart-price').toggleClass('active');
            if($extra.length > 0){
                $extra.attr('href', $extra.data('day'))
            }

        }
    }

});
